import React from "react";
import Icon from "../Icon";
import _Button from "../generic/_Button";
import PropTypes from "prop-types";
import useFileInput from "../../hooks/upload/useFileInput";
import { ProgressBar } from "../ui/ProgressBar";
import useFileUpload from "../../hooks/upload/useFileUpload";

const MediaUpload = ({
  previewUrl,
  setPreviewUrl,
  setFile,
  selectedTypeFile,
  config,
}) => {
  const { ref: fileInputRef, open } = useFileInput();
  const { upload, initProgress, progress, fileInformation } = useFileUpload();

  const handleFile = (event) => {
    const file = event.target.files?.[0];

    upload(file);
    if (!file) return;

    const allowedTypes = new Set([
      "image/jpeg",
      "image/png",
      "application/pdf",
      "image/gif",
      "image/jpg",
    ]);

    if (file && allowedTypes.has(file.type)) {
      setFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  if (initProgress) {
    return (
      <div>
        Cargando archivo... {progress}%
        <ProgressBar percentage={progress} />
      </div>
    );
  }

  return (
    <div>
      {!previewUrl ? (
        <>
          <div
            className="flex flex-col items-center justify-center rounded-lg border-2 border-gray-300 border-dashed border-border p-8 text-center"
            onClick={open}
          >
            <div className="flex justify-center gap-2">
              <Icon icon={config?.icon} />
              <div className="mb-2 text-sm text-muted-foreground text-gray-600">
                {config?.uploadTitle}
              </div>
            </div>
            <input
              ref={fileInputRef}
              type="file"
              accept={config?.uploadAccept}
              onChange={handleFile}
              className="hidden"
            />
          </div>
          <div className="flex justify-end mt-2">
            <_Button
              title={config?.uploadButton}
              icon="upload"
              style="none"
              onClick={() => fileInputRef.current.click()}
            />
          </div>
        </>
      ) : (
        <div className="relative rounded-lg border border-border p-4">
          {selectedTypeFile !== "image" ? (
            fileInformation?.size < 5242880 ? (
              <iframe
                src={previewUrl}
                className="w-full rounded-md"
                style={{ height: "300px" }}
              />
            ) : (
              <div className="flex flex-col items-center justify-center rounded-lg border-2 border-gray-300 border-dashed border-border p-8 text-center max-h-[300px]">
                <span className="material-symbols-outlined text-sm text-muted-foreground text-gray-600" style={{
                  fontSize: "48px",
                }}>
                  picture_as_pdf
                </span>
                <div className="mb-2 text-sm text-muted-foreground text-gray-600">
                 {fileInformation?.name}
                </div>
              </div>
            )
          ) : (
            <img
              src={previewUrl}
              alt="Preview"
              className="h-auto w-full rounded-md object-contain"
              style={{ maxHeight: "300px" }}
            />
          )}

          <button
            onClick={() => {
              setPreviewUrl(null);
            }}
            className="absolute top-2 right-2 rounded-full bg-black-50 hover:bg-black  hover:text-white border-none flex items-center p-2"
          >
            <Icon icon="close" className={"hover:text-white"} />
          </button>
        </div>
      )}
    </div>
  );
};

MediaUpload.propTypes = {
  previewUrl: PropTypes.string,
  setPreviewUrl: PropTypes.func,
  setFile: PropTypes.func,
  selectedTypeFile: PropTypes.string,
  config: PropTypes.object,
};

export default MediaUpload;
